export const ITEM_KEY_HOME = 'form.home';
export const ITEM_KEY_CHARSET = 'form.charset';
export const ITEM_KEY_ACCESS_TOKEN = 'form.accessToken';